/* ═══════════════════════════════════════════════════════════════
   ICI FRONT LAYER v4 — B1+B2+B7+B8+P7+TURBO del prompt maestro 2026-08-23
   ICI SEARCH v4 (2026-10-12): B1/B2 delegados a assets/ici-search-engine.js
   1) B1: reescritor AND-first con cascada de degradación
   2) B2: diccionario ferretero salvadoreño (expansión OR por concepto)
   3) B7: barra inferior móvil funcional (<750px): hoja de categorías
      propia, buscador overlay propio, widgets flotantes (WhatsApp/asesor)
      elevados sobre la barra sin quitarlos, modo claro/oscuro.
   4) B8: eager-fix de imágenes sobre el pliegue
   5) P7: insignia "Ahorrás $X" en tarjetas con descuento
   Datos: window.ICISearchData (inyectado desde snippets/meta-tags.liquid)
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var STOP = ['de', 'del', 'la', 'el', 'los', 'las', 'un', 'una', 'unos', 'unas',
    'para', 'con', 'y', 'o', 'u', 'en', 'por', 'a', 'al', 'lo', 'le', 'su', 'mi', 'tu', 'que'];

  /* ── B2 · Diccionario ferretero (nivel 1, alta confianza).
         Cada grupo se expande a (t1* OR t2* …) dentro del AND. ── */
  var SYN_GROUPS = [
    ['perlin', 'polin'],
    ['desarmador', 'destornillador', 'atornillador'],
    ['chispero', 'chisquero', 'encendedor'],
    ['lamina', 'zinc', 'calamina'],
    ['varilla', 'corrugado'],
    ['alicate', 'pinza'],
    ['esmeril', 'pulidora', 'amoladora'],
    ['rotomartillo', 'percutor'],
    ['foco', 'bombillo'],
    ['tomacorriente', 'enchufe'],
    ['pega', 'pegamento'],
    ['cepo', 'mordaza'],
    ['tarugo', 'taquete'],
    ['perico', 'llave'],
    ['freon', 'refrigerante'],
    ['minisplit', 'split'],
    ['cassette', 'casete'],
    ['ducto', 'ducteria'],
    ['manometro', 'manifold']
  ];
  var SYN = {};
  SYN_GROUPS.forEach(function (g) { g.forEach(function (t) { SYN[t] = g; }); });

  function normalize(s) {
    return String(s || '').toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ').trim();
  }

  function looksLikeCode(q) {
    return /^[a-z]{0,5}-?[0-9]{3,}[a-z0-9-]*$/i.test(String(q).replace(/\s+/g, ''));
  }

  function hasOperators(q) {
    return /["*:()]|\bAND\b|\bOR\b|\bNOT\b/.test(q);
  }

  function isMeasure(t) {
    return /^[0-9]+(\/[0-9]+|\.[0-9]+)?(in|mm|cm|mts?|lbs?|kg|gal|w|v|ah?|hp|l|ml|oz|pulg|pulgadas)?$/.test(t);
  }

  function tokens(q) {
    return normalize(q)
      .replace(/["']/g, ' ')
      .split(' ')
      .filter(function (t) { return t && STOP.indexOf(t) === -1; });
  }

  function stemKey(t) {
    if (SYN[t]) return t;
    if (t.length > 3 && t.slice(-1) === 's' && SYN[t.slice(0, -1)]) return t.slice(0, -1);
    if (t.length > 4 && t.slice(-2) === 'es' && SYN[t.slice(0, -2)]) return t.slice(0, -2);
    return null;
  }

  function wc(t) {
    return (/^[a-zñ]{3,}$/.test(t) && !isMeasure(t)) ? t + '*' : t;
  }

  /* Un token → su término con comodín, o su grupo de sinónimos (a* OR b*) */
  function expand(t) {
    var key = stemKey(t);
    if (key) {
      return '(' + SYN[key].map(function (s) { return s + '*'; }).join(' OR ') + ')';
    }
    return wc(t);
  }

  function buildAnd(toks) {
    if (toks.length === 1) return expand(toks[0]);
    return toks.map(expand).join(' AND ');
  }

  /* Devuelve la consulta reescrita o null si no aplica */
  function rewrite(q) {
    var raw = String(q || '').trim();
    if (raw.length < 3 || hasOperators(raw) || looksLikeCode(raw)) return null;
    var toks = tokens(raw);
    if (toks.length < 1) return null;
    /* 1 token: solo se reescribe si tiene grupo de sinónimos */
    if (toks.length === 1 && !stemKey(toks[0])) return null;
    return buildAnd(toks);
  }

  /* ── Taxonomía: términos que el enrutador v3 resuelve mejor ── */
  var taxSet = null;
  var taxReady = null;
  var menuRaw = null;

  function taxAdd(x) {
    if (x) taxSet.add(normalize(String(x).replace(/-/g, ' ')));
  }

  function loadTax() {
    if (taxReady) return taxReady;
    var url = (window.ICISearchData || {}).menuUrl;
    if (!url) { taxReady = Promise.resolve(); return taxReady; }
    taxReady = fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        menuRaw = d;
        taxSet = new Set();
        (d.departments || []).forEach(function (dep) {
          taxAdd(dep.label); taxAdd(dep.slug);
          (dep.categories || []).forEach(function (c) {
            taxAdd(c.label); taxAdd(c.slug);
            (c.subcategories || []).forEach(function (s) { taxAdd(s.label); taxAdd(s.slug); });
          });
        });
        (d.brands || []).forEach(function (b) { taxAdd(b.label); });
      })
      .catch(function () { taxSet = null; });
    return taxReady;
  }

  function isTaxonomyTerm(q) {
    return !!(taxSet && taxSet.has(normalize(q)));
  }

  loadTax();

  /* ── B1 · Intercepción de TODOS los formularios de búsqueda ── */
  function addHidden(form, name, value) {
    var el = form.querySelector('input[name="' + name + '"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      form.appendChild(el);
    }
    el.value = value;
  }

  /* ── ICI SEARCH v4 (2026-10-12) · Intercepción de TODOS los formularios de búsqueda.
         Usa el motor compartido (assets/ici-search-engine.js): corrige ortografía, expande
         sinónimos salvadoreños y NO usa comodines ni AND explícito (medido: inflaban a
         1,000 resultados con ruido). Ya no se cede la búsqueda al enrutador de taxonomía. ── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var E = window.ICISearch;
    if (!E) return;
    var original = input.value;
    var p = E.plan(original);
    E.track(original, p);
    addHidden(form, 'options[unavailable_products]', 'show');
    if (!p.changed) return;
    addHidden(form, 'oq', original.trim());
    addHidden(form, 'ici_att', '1');
    input.value = p.q;
  }, true);

  /* ── B1 · Cascada de degradación en la página /search ── */
  function go(params) {
    params['options[unavailable_products]'] = 'show';
    var qs = new URLSearchParams(params).toString();
    window.location.replace(location.pathname + '?' + qs);
  }

  function notice(html) {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    var div = document.createElement('div');
    div.className = 'icir-notice ici-rescue-scope';
    div.style.cssText = 'max-width:920px;margin:0 auto 2rem;padding:14px 20px;background:#E7F0FF;border:1.5px solid #cfe0f7;border-radius:16px;font-size:15px;color:#302783;font-family:Poppins,sans-serif;';
    div.innerHTML = '<span>' + html + '</span>';
    grid.parentNode.insertBefore(div, grid);
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function fixDisplay(oq, rewritten) {
    if (!oq || !rewritten) return;
    document.querySelectorAll('input[name="q"]').forEach(function (i) {
      if (i.value === rewritten) i.value = oq;
    });
    ['#ProductCount', '#ProductCountDesktop'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && el.textContent.indexOf(rewritten) !== -1) {
        el.textContent = el.textContent.split(rewritten).join('«' + oq + '»');
      }
    });
    document.querySelectorAll('.template-search__header p[role="status"], .ici-crocl-srch__title strong, .ici-crocl-srch__title').forEach(function (p) {
      if (p.children.length === 0 && p.textContent.indexOf(rewritten) !== -1) {
        p.textContent = p.textContent.split(rewritten).join(oq);
      }
    });
    try { if (document.title.indexOf(rewritten) !== -1) document.title = document.title.split(rewritten).join(oq); } catch (e) { }
    /* Rescate D2: el WhatsApp debe citar lo que escribió el cliente, no la consulta interna */
    document.querySelectorAll('[data-ici-rsc-wa]').forEach(function (a) {
      if (a.dataset.iciOq) return;
      a.dataset.iciOq = '1';
      a.href = 'https://wa.me/50368353128?text=' + encodeURIComponent('Hola ICI, busqué "' + oq + '" en icielsalvador.com y no lo encontré. ¿Me ayudan a conseguirlo?');
    });
  }

  /* ICI SEARCH v4: si lo buscado es el nombre de un departamento o categoría del menú, se ofrece un atajo
     (NO se redirige: el cliente decide). Subcategorías no: algunas no tienen página propia. */
  function taxNode(q) {
    if (!menuRaw || !menuRaw.departments) return null;
    var nq = normalize(String(q || '').replace(/-/g, ' '));
    var sq = nq.replace(/(es|s)$/, '');
    var same = function (label, slug) {
      var a = normalize(String(label || '').replace(/-/g, ' ')), b = normalize(String(slug || '').replace(/-/g, ' '));
      return a === nq || b === nq || a.replace(/(es|s)$/, '') === sq || b.replace(/(es|s)$/, '') === sq;
    };
    var deps = menuRaw.departments, i, j;
    for (i = 0; i < deps.length; i++) {
      if (same(deps[i].label, deps[i].slug)) return { label: deps[i].label, url: deptUrl(deps[i].slug), tipo: 'departamento' };
    }
    for (i = 0; i < deps.length; i++) {
      var cs = deps[i].categories || [];
      for (j = 0; j < cs.length; j++) {
        if (cs[j].slug && same(cs[j].label, cs[j].slug)) return { label: cs[j].label, url: '/collections/' + cs[j].slug, tipo: 'categoría' };
      }
    }
    return null;
  }

  function onSearchPage() {
    var data = window.ICISearchData || {};
    if (!data.performed) return;
    var usp = new URLSearchParams(location.search);
    var oq = usp.get('oq') || '';
    var att = parseInt(usp.get('ici_att') || '0', 10);
    var count = data.count || 0;
    var terms = data.terms || '';
    var E = window.ICISearch;
    var browsing = usp.has('page') || usp.has('sort_by') || Array.from(usp.keys()).some(function (k) { return k.indexOf('filter.') === 0; });
    if (E) E.track(oq || terms, null, count);

    /* Llegada directa (link externo, Google, WhatsApp, historial) sin pasar por el buscador:
       se aplica el motor una sola vez si cambia algo (sinónimo o corrección). */
    if (E && att === 0 && !oq && !browsing && terms && terms !== '*' && !/[*()"]/.test(terms)) {
      E.ready().then(function (ok) {
        if (!ok) return;
        var p = E.plan(terms);
        if (p.changed) go({ q: p.q, oq: terms, ici_att: '1', type: 'product' });
      });
    }

    /* 0 resultados: (1) corrección ortográfica completa contra el catálogo; (2) si no, quitar la última palabra */
    if (count === 0 && E && !browsing && att <= 1 && terms && terms !== '*') {
      var src = oq || terms;
      E.ready().then(function (ok) {
        if (!ok) return;
        var pf = E.plan(src, { full: true });
        if (pf.changed && pf.q !== terms) { go({ q: pf.q, oq: src, ici_att: '2', icifix: '1', type: 'product' }); return; }
        var toks = tokens(src);
        if (toks.length >= 2) {
          var p2 = E.plan(toks.slice(0, -1).join(' '), { full: true });
          go({ q: p2.q, oq: src, ici_att: '2', icidrop: toks[toks.length - 1], type: 'product' });
        }
      });
    }

    if (count > 0 && oq && att === 2 && usp.get('icifix') && E) {
      E.ready().then(function () {
        var msg = E.describe(E.plan(oq, { full: true }));
        if (msg) notice(msg);
      });
    }
    if (count > 0 && oq && att === 2 && usp.get('icidrop')) {
      var kept = tokens(oq).slice(0, -1).join(' ');
      var dropped = usp.get('icidrop') || '';
      notice('No encontramos <strong>' + esc(oq) + '</strong>. Te mostramos resultados para <strong>' + esc(kept) + '</strong>' + (dropped ? ' (sin «' + esc(dropped) + '»)' : '') + '.');
    }
    if (count > 0 && oq && att === 1 && E && !browsing) {
      E.ready().then(function () {
        var msg = E.describe(E.plan(oq));
        if (msg) notice(msg);
      });
    }

    /* Resultados sin relación con lo buscado (catálogo no lo tiene): aviso honesto + WhatsApp */
    if (E && count > 0 && !browsing && terms && terms !== '*') {
      Promise.all([E.ready(), loadTax()]).then(function (res) {
        var ok = res[0];
        var src = oq || terms;
        var tx = taxNode(src);
        if (tx) {
          notice('¿Buscás el ' + tx.tipo + ' <strong>' + esc(tx.label) + '</strong>? <a href="' + tx.url + '" style="color:#101EAE;font-weight:700;text-decoration:underline">Ver todo en ' + esc(tx.label) + ' →</a>');
          return;
        }
        if (!ok) return;
        var pl = E.plan(src);
        if (pl.code || !pl.terms || !pl.terms.length) return;
        var cards = Array.prototype.slice.call(document.querySelectorAll('#ProductGridContainer .card__heading')).slice(0, 8);
        if (!cards.length) return;
        var rel = cards.filter(function (c) { return E.relevant({ title: c.textContent }, pl); }).length;
        if (rel > 0) return;
        var wa = 'https://wa.me/50368353128?text=' + encodeURIComponent('Hola ICI, busqué "' + src + '" en icielsalvador.com y no lo encontré. ¿Me ayudan a conseguirlo?');
        notice('No tenemos <strong>' + esc(src) + '</strong> publicado en línea; abajo hay resultados aproximados. <a href="' + wa + '" target="_blank" rel="noopener" style="color:#101EAE;font-weight:700;text-decoration:underline">Te lo conseguimos por WhatsApp</a>.');
        try { if (window.clarity) window.clarity('event', 'ici_busqueda_sin_relevantes'); } catch (e) { }
      });
    }

    fixDisplay(oq, terms);

    var grid = document.getElementById('ProductGridContainer');
    if (grid && oq) {
      new MutationObserver(function () { fixDisplay(oq, terms); })
        .observe(grid, { childList: true, subtree: true });
    }
  }

  /* ── B8 · Eager-fix: primeras imágenes visibles no deben ser lazy ── */
  function eagerFix() {
    try {
      var flipped = 0;
      var imgs = document.querySelectorAll('img[loading="lazy"]');
      var vh = window.innerHeight || 800;
      for (var i = 0; i < imgs.length && flipped < 8; i++) {
        var r = imgs[i].getBoundingClientRect();
        if (r.top < vh && r.bottom > 0 && r.width > 40) {
          imgs[i].loading = 'eager';
          imgs[i].setAttribute('fetchpriority', 'high');
          flipped++;
        }
      }
    } catch (e) { }
  }

  /* ── P7 · Insignia "Ahorrás $X" en tarjetas con precio rebajado ── */
  function parseMoney(t) {
    var m = String(t || '').replace(/[^0-9.,]/g, '').replace(/,/g, '');
    var v = parseFloat(m);
    return isNaN(v) ? null : v;
  }

  function savingsBadges(root) {
    try {
      var cards = (root || document).querySelectorAll('.card__information .price--on-sale');
      cards.forEach(function (p) {
        if (p.dataset.iciSave) return;
        p.dataset.iciSave = '1';
        /* ICI CROCL-C4 v1 (2026-09-22): si la tarjeta ya trae "Ahorrás" en Liquid (ici-card-meta), no duplicar */
        var cw = p.closest('.card-wrapper, .card__content');
        if (cw && cw.querySelector('.ici-card-meta__save')) return;
        var regEl = p.querySelector('s.price-item--regular, .price__sale s');
        var saleEl = p.querySelector('.price-item--sale');
        if (!regEl || !saleEl) return;
        var reg = parseMoney(regEl.textContent);
        var sale = parseMoney(saleEl.textContent);
        if (reg === null || sale === null || reg - sale < 0.05) return;
        var b = document.createElement('span');
        b.className = 'ici-save-badge';
        b.textContent = 'Ahorrás $' + (reg - sale).toFixed(2);
        b.style.cssText = 'display:inline-block;margin-top:4px;padding:2px 10px;background:#FFDC00;color:#101EAE;border-radius:999px;font-size:11px;font-weight:800;font-family:Poppins,sans-serif;line-height:1.6;';
        p.appendChild(b);
      });
    } catch (e) { }
  }

  /* ══ B7 v3 · Barra inferior móvil FUNCIONAL (<750px) ══
     - Categorías: hoja propia con los departamentos de ici_menu_active.json
       (no depende del header del tema).
     - Buscar: overlay propio con formulario a /search (pasa por el
       reescritor B1 automáticamente).
     - WhatsApp (#chat-bubble) y asesor (#ici-asesor-wrap) se ELEVAN sobre
       la barra: se conservan siempre visibles (CTA principal del negocio).
     - Modo claro/oscuro vía prefers-color-scheme. Safe-area iOS. ── */
  /* ICI MOB-UI v1 (2026-10-16): iconos SVG de linea en lugar de emojis */ var ICI_SVG = function (p, s) { s = s || 20; return '<svg viewBox="0 0 24 24" width="' + s + '" height="' + s + '" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>'; }; var ICI_TAG = '<path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/>'; var ICI_STAR = '<path d="M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.3l-5.6 2.9 1.1-6.2L3 9.6l6.2-.9z"/>'; var ICI_X = '<path d="M18 6L6 18M6 6l12 12"/>'; var ICI_CHEV = '<path d="M9 6l6 6-6 6"/>'; var ICI_GRID = '<rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>'; var DEPT_ICONS = { 'navidad': '<path d="M12 3L6 11h3l-4 6h14l-4-6h3z"/><path d="M12 17v4"/>', 'aire-acondicionado': '<path d="M12 2v20M3.3 7l17.4 10M3.3 17L20.7 7"/><path d="M9 4l3 2 3-2M9 20l3-2 3 2"/>', 'almacenaje-y-organizacion': '<path d="M21 8l-9-5-9 5v8l9 5 9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/>', 'automotriz': '<path d="M3 13l2.2-5.5A2 2 0 0 1 7 6h10a2 2 0 0 1 1.8 1.5L21 13v4H3z"/><circle cx="7.5" cy="17" r="1.8"/><circle cx="16.5" cy="17" r="1.8"/>', 'deportes-y-aire-libre': '<path d="M3 20L12 4l9 16z"/><path d="M12 4v16M9.5 20l2.5-5 2.5 5"/>', 'electricidad': '<path d="M13 2L4 14h7l-1 8 9-12h-7z"/>', 'equipaje-y-viajes': '<rect x="3" y="7" width="18" height="13" rx="2"/><path d="M9 7V4h6v3M8 11v5M16 11v5"/>', 'ferreteria': '<path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.6 2.6-2.4-.6-.6-2.4z"/>', 'fontaneria': '<path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z"/>', 'hogar': '<path d="M3 10.5L12 3l9 7.5V21h-6v-6H9v6H3z"/>', 'jardineria-y-agro': '<path d="M12 21v-9M12 12C12 7 9 4 4 4c0 5 3 8 8 8zM12 14c0-4 3-6 8-6 0 4-3 6-8 6z"/>', 'construccion': '<rect x="3" y="5" width="18" height="14" rx="1.5"/><path d="M3 12h18M12 5v7M8 12v7M16 12v7"/>', 'oficina-y-papeleria': '<rect x="5" y="4" width="14" height="17" rx="2"/><path d="M9 3h6v3H9zM9 11h6M9 15h4"/>', 'pinturas': '<rect x="3" y="3" width="15" height="6" rx="1.5"/><path d="M18 6h3v6h-9v3"/><rect x="10.5" y="15" width="3" height="6" rx="1"/>', 'ropa-y-accesorios': '<path d="M8 3L3 6l2 5 3-1v11h8V10l3 1 2-5-5-3a4 4 0 0 1-8 0z"/>', 'seguridad-industrial': '<path d="M3 18h18M5 18v-3a7 7 0 0 1 14 0v3M10 8.5V5h4v3.5"/>', 'tecnologia': '<rect x="4" y="5" width="16" height="11" rx="1.5"/><path d="M2 20h20"/>', 'mascotas': '<circle cx="6" cy="11" r="1.8"/><circle cx="18" cy="11" r="1.8"/><circle cx="9.5" cy="6.5" r="1.8"/><circle cx="14.5" cy="6.5" r="1.8"/><path d="M12 13c-3 0-5 3.2-5 5.2 0 1.6 1.6 2.1 2.7 1.6.9-.4 1.5-.6 2.3-.6s1.4.2 2.3.6c1.1.5 2.7 0 2.7-1.6 0-2-2-5.2-5-5.2z"/>' };
  /* Departamentos sin colección propia todavía → búsqueda enrutada */
  var DEPT_URL_EXCEPTIONS = { 'ferreteria': '/collections/ferreteria', 'automotriz': '/collections/automotriz-ici' }; /* ICI SEARCH v4: ya no se enruta por búsqueda */

  function deptUrl(slug) {
    return DEPT_URL_EXCEPTIONS[slug] || ('/collections/' + slug);
  }

  function closeSheets() {
    ['ici-msheet', 'ici-msearch', 'ici-mshade'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.classList.remove('on');
    });
  }

  function openShade() {
    var sh = document.getElementById('ici-mshade');
    if (sh) sh.classList.add('on');
  }

  function buildOverlays() {
    if (document.getElementById('ici-mshade')) return;

    var shade = document.createElement('div');
    shade.id = 'ici-mshade';
    shade.addEventListener('click', closeSheets);
    document.body.appendChild(shade);

    /* Hoja de categorías */
    var sheet = document.createElement('div');
    sheet.id = 'ici-msheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-label', 'Departamentos');
    var head = '<header><h3>Comprá por departamento</h3><button type="button" class="ici-msheet__x" aria-label="Cerrar">' + ICI_SVG(ICI_X, 18) + '</button></header>';
    var links = '<nav><a href="/collections/promociones" class="ici-msheet__promo"><span class="ici-msheet__ico">' + ICI_SVG(ICI_TAG) + '</span><span class="ici-msheet__lbl">Promociones</span>' + ICI_SVG(ICI_CHEV, 16) + '</a><a href="/collections/promo-semanal-ici-sisimiles" class="ici-msheet__promo"><span class="ici-msheet__ico">' + ICI_SVG(ICI_STAR) + '</span><span class="ici-msheet__lbl">Promo de la semana</span>' + ICI_SVG(ICI_CHEV, 16) + '</a>';
    var deps = (menuRaw && menuRaw.departments) || [];
    deps.forEach(function (d) {
      links += '<a href="' + deptUrl(d.slug) + '">' + '<span class="ici-msheet__ico">' + ICI_SVG(DEPT_ICONS[d.slug] || ICI_GRID) + '</span><span class="ici-msheet__lbl">' + esc(d.label) + '</span>' + ICI_SVG(ICI_CHEV, 16) + '</a>';
    });
    links += '</nav>';
    sheet.innerHTML = head + links;
    sheet.querySelector('.ici-msheet__x').addEventListener('click', closeSheets);
    document.body.appendChild(sheet);

    /* Overlay de búsqueda (el submit pasa por el reescritor B1) */
    var so = document.createElement('div');
    so.id = 'ici-msearch';
    so.setAttribute('role', 'dialog');
    so.setAttribute('aria-label', 'Buscar productos');
    so.innerHTML =
      '<form action="/search" method="get" role="search">' +
      '<button type="button" class="ici-msearch__x" aria-label="Cerrar">' + ICI_SVG(ICI_X, 20) + '</button>' +
      '<input type="search" name="q" placeholder="¿Qué estás buscando?" autocomplete="off" autocapitalize="off" spellcheck="false">' +
      '<input type="hidden" name="type" value="product">' +
      '<button type="submit">Ir</button></form>';
    so.querySelector('.ici-msearch__x').addEventListener('click', closeSheets);
    document.body.appendChild(so);
  }

  function toggleSheet() {
    var open = document.getElementById('ici-msheet').classList.contains('on');
    closeSheets();
    if (!open) {
      openShade();
      document.getElementById('ici-msheet').classList.add('on');
    }
  }

  function toggleSearch() {
    var so = document.getElementById('ici-msearch');
    var open = so.classList.contains('on');
    closeSheets();
    if (!open) {
      openShade();
      so.classList.add('on');
      setTimeout(function () { try { so.querySelector('input[name="q"]').focus(); } catch (e) { } }, 240);
    }
  }

  function mobileBar() {
    if (window.innerWidth >= 750) return;
    if (document.getElementById('ici-mbar')) return;
    var css = document.createElement('style');
    css.id = 'ici-mbar-css';
    css.textContent =
      '#ici-mbar{position:fixed;left:0;right:0;bottom:0;z-index:2147482000;display:flex;background:#fff;border-top:1px solid #e0ecf5;box-shadow:0 -4px 18px rgba(16,30,174,.10);padding-bottom:env(safe-area-inset-bottom,0px);font-family:Poppins,sans-serif;transition:transform .25s ease;}' +
      '#ici-mbar.ici-mbar--hide{transform:translateY(110%);}' +
      '#ici-mbar a,#ici-mbar button{flex:1 1 0;min-height:56px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;background:none;border:0;color:#101EAE;font-size:10.5px;font-weight:600;text-decoration:none;cursor:pointer;-webkit-tap-highlight-color:transparent;}' +
      '#ici-mbar svg{width:22px;height:22px;stroke:#101EAE;fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}' +
      '#ici-mbar .ici-mbar__cart{position:relative;}' +
      /* ICI MBAR-3 (2026-10-28): misma fuente, tamano y peso en los 4 elementos */
      '#ici-mbar{-webkit-text-size-adjust:100%;text-size-adjust:100%;}#ici-mbar>a,#ici-mbar>button{font-family:Poppins,system-ui,sans-serif !important;font-size:11px !important;font-weight:500 !important;line-height:1.2 !important;letter-spacing:0 !important;text-transform:none !important;padding:6px 2px !important;margin:0 !important;min-width:0;gap:3px;}' +
      '#ici-mbar>a>span,#ici-mbar>button>span{display:block;font:inherit !important;white-space:nowrap;}' +
      '#ici-mbar>a>svg,#ici-mbar>button>svg{width:22px !important;height:22px !important;flex:none;}' +
      '#ici-mbar .ici-mbar--on{color:#0a0a0a;}#ici-mbar .ici-mbar--on svg{stroke:#1EA4D9;}' +
      '#ici-mbar .ici-mbar__n{position:absolute;top:4px;right:calc(50% - 20px);background:#FFDC00;color:#101EAE;font-size:9.5px;font-weight:800;border-radius:999px;min-width:16px;height:16px;line-height:16px;text-align:center;padding:0 3px;}' +
      'body{padding-bottom:calc(64px + env(safe-area-inset-bottom,0px));}' +
      /* WhatsApp y asesor: SIEMPRE visibles, elevados sobre la barra */
      '@media(max-width:749.98px){' +
      '#chat-bubble{bottom:calc(72px + env(safe-area-inset-bottom,0px)) !important;}' +
      '#ici-asesor-wrap{bottom:calc(76px + env(safe-area-inset-bottom,0px)) !important;}' +
      '#ici-asesor-panel{bottom:calc(132px + env(safe-area-inset-bottom,0px)) !important;}' +
      '}' +
      /* Sombra de fondo */
      '#ici-mshade{position:fixed;inset:0;z-index:2147482100;background:rgba(10,16,60,.45);opacity:0;pointer-events:none;transition:opacity .22s;}' +
      '#ici-mshade.on{opacity:1;pointer-events:auto;}' +
      /* Hoja de categorías */
      '#ici-msheet{position:fixed;left:0;right:0;bottom:0;z-index:2147482200;background:#fff;border-radius:18px 18px 0 0;box-shadow:0 -10px 40px rgba(0,0,0,.28);transform:translateY(105%);transition:transform .24s ease;max-height:72vh;display:flex;flex-direction:column;font-family:Poppins,sans-serif;padding-bottom:calc(64px + env(safe-area-inset-bottom,0px));}' +
      '#ici-msheet.on{transform:translateY(0);}' +
      '#ici-msheet header{display:flex;align-items:center;justify-content:space-between;padding:14px 18px 6px;flex:0 0 auto;}' +
      '#ici-msheet h3{margin:0;font-size:16px;font-weight:800;color:#101EAE;}' +
      '#ici-msheet .ici-msheet__x{background:none;border:0;font-size:20px;line-height:1;color:#101EAE;padding:8px 12px;cursor:pointer;}' +
      '#ici-msheet nav{overflow-y:auto;-webkit-overflow-scrolling:touch;padding:0 10px 12px;}' +
      '#ici-msheet nav a{display:flex;align-items:center;min-height:48px;padding:0 12px;border-radius:12px;color:#1a1a2e;text-decoration:none;font-size:14.5px;font-weight:600;}' +
      '#ici-msheet nav a:active{background:#E7F0FF;}' +
      '#ici-msheet nav a.ici-msheet__promo{color:#101EAE;font-weight:800;}' + /* ICI MOB-UI v1: hoja de categorias con iconos y bordes de marca */ '#ici-msheet{border-radius:28px 28px 0 0;}#ici-msheet header{padding:18px 18px 12px;}#ici-msheet h3{color:#0a0a0a;font-size:17px;}#ici-msheet .ici-msheet__x{width:40px;height:40px;padding:0;border-radius:50px;background:#e8f6fc;color:#1ea4d9;display:flex;align-items:center;justify-content:center;}#ici-msheet nav{display:flex;flex-direction:column;gap:8px;padding:4px 16px 16px;}#ici-msheet nav a{gap:12px;min-height:52px;padding:0 16px 0 8px;border:1.5px solid #d4ecf7;border-radius:50px;background:transparent;font-weight:600;}#ici-msheet nav a:active{background:#e8f6fc;border-color:#1ea4d9;}#ici-msheet nav a > svg{margin-left:auto;color:#1ea4d9;flex:0 0 16px;}#ici-msheet .ici-msheet__ico{width:36px;height:36px;flex:0 0 36px;border-radius:50px;background:#e8f6fc;color:#1ea4d9;display:flex;align-items:center;justify-content:center;}#ici-msheet .ici-msheet__lbl{flex:1 1 auto;min-width:0;}#ici-msheet nav a.ici-msheet__promo{background:#1ea4d9;border-color:#1ea4d9;color:#fff;font-weight:700;}#ici-msheet nav a.ici-msheet__promo .ici-msheet__ico{background:rgba(255,255,255,.22);color:#fff;}#ici-msheet nav a.ici-msheet__promo > svg{color:#fff;}#ici-msearch .ici-msearch__x{display:flex;align-items:center;}' +
      /* Overlay de búsqueda */
      '#ici-msearch{position:fixed;left:0;right:0;top:0;z-index:2147482200;background:#fff;padding:calc(10px + env(safe-area-inset-top,0px)) 12px 12px;box-shadow:0 6px 24px rgba(0,0,0,.18);transform:translateY(-110%);transition:transform .2s ease;font-family:Poppins,sans-serif;}' +
      '#ici-msearch.on{transform:translateY(0);}' +
      '#ici-msearch form{display:flex;gap:8px;align-items:center;}' +
      '#ici-msearch input[name="q"]{flex:1 1 auto;min-width:0;min-height:46px;border:2px solid #101EAE;border-radius:12px;padding:0 14px;font-size:16px;color:#1a1a2e;background:#fff;-webkit-appearance:none;}' +
      '#ici-msearch button[type="submit"]{flex:0 0 auto;min-width:54px;min-height:46px;border:0;border-radius:12px;background:#101EAE;color:#fff;font-weight:800;font-size:14px;font-family:Poppins,sans-serif;cursor:pointer;}' +
      '#ici-msearch .ici-msearch__x{flex:0 0 auto;background:none;border:0;color:#101EAE;font-size:20px;padding:8px 6px;cursor:pointer;}' +
      /* Modo oscuro */
      '@media(prefers-color-scheme:dark){' +
      '#ici-mbar{background:#12172b;border-top-color:#26304f;box-shadow:0 -4px 18px rgba(0,0,0,.55);}' +
      '#ici-mbar a,#ici-mbar button{color:#dbe6ff;}' +
      '#ici-mbar svg{stroke:#dbe6ff;}' +
      '#ici-mbar .ici-mbar__n{background:#FFDC00;color:#101EAE;}' +
      '#ici-msheet{background:#12172b;}' +
      '#ici-msheet h3,#ici-msheet .ici-msheet__x{color:#dbe6ff;}' +
      '#ici-msheet nav a{color:#dbe6ff;}' +
      '#ici-msheet nav a:active{background:#1c2440;}' +
      '#ici-msheet nav a.ici-msheet__promo{color:#9db8ff;}' +
      '#ici-msearch{background:#12172b;}' +
      '#ici-msearch input[name="q"]{background:#0d1120;border-color:#3a4a7d;color:#eef2ff;}' +
      '#ici-msearch .ici-msearch__x{color:#dbe6ff;}' +
      '}' +
      '@media(min-width:750px){#ici-mbar,#ici-msheet,#ici-mshade,#ici-msearch{display:none}body{padding-bottom:0}}';
    document.head.appendChild(css);

    var cartCount = 0;
    try {
      var bubble = document.querySelector('.cart-count-bubble span[aria-hidden]');
      if (bubble) cartCount = parseInt(bubble.textContent, 10) || 0;
    } catch (e) { }

    var bar = document.createElement('nav');
    bar.id = 'ici-mbar';
    bar.setAttribute('aria-label', 'Navegación rápida');
    bar.innerHTML =
      '<button type="button" id="ici-mbar-cats" aria-label="Categorías" aria-haspopup="dialog"><svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg><span>Categorías</span></button>' +
      '<a href="/collections/promociones" data-ici-mbar="/collections/promociones" aria-label="Promociones"><svg viewBox="0 0 24 24"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg><span>Promos</span></a>' +
      '<a href="/pages/construye" data-ici-mbar="/pages/construye" aria-label="Constru ICI"><svg viewBox="0 0 24 24"><path d="M3 21h18"/><path d="M5 21V8l7-5 7 5v13"/><path d="M9 21v-5h6v5"/><path d="M9 10h1.5M13.5 10H15"/></svg><span>Constru ICI</span></a>' +
      '<a href="https://constru.icielsalvador.com/" aria-label="Mi cuenta"><svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg><span>Mi cuenta</span></a>';
    /* ICI MBAR-2 (2026-10-28): barra inferior movil = Categorias, Promociones, Constru ICI, Mi cuenta (buscador, favoritos y carrito ya estan en el header) */
    document.body.appendChild(bar);
    try { bar.querySelectorAll('[data-ici-mbar]').forEach(function (l) { if (location.pathname.indexOf(l.getAttribute('data-ici-mbar')) === 0) l.classList.add('ici-mbar--on'); }); } catch (e) { }

    document.getElementById('ici-mbar-cats').addEventListener('click', function () {
      loadTax().then(function () { buildOverlays(); toggleSheet(); });
    });
    var iciMbarSearch = document.getElementById('ici-mbar-search');
    if (iciMbarSearch) iciMbarSearch.addEventListener('click', function () {
      buildOverlays();
      toggleSearch();
    });

    /* Auto-ocultar al scrollear hacia abajo (el header sticky ya cubre arriba) */
    var lastY = window.scrollY, accUp = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var dy = y - lastY; lastY = y;
      if (y < 80) { bar.classList.remove('ici-mbar--hide'); accUp = 0; return; }
      if (dy > 6) { bar.classList.add('ici-mbar--hide'); accUp = 0; }
      else if (dy < 0) { accUp -= dy; if (accUp > 24) { bar.classList.remove('ici-mbar--hide'); accUp = 0; } }
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSheets();
    });
  }

  /* ── TURBO · Navegación instantánea: prerender/prefetch especulativo ── */
  function turbo() {
    try {
      if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
        var s = document.createElement('script');
        s.type = 'speculationrules';
        s.textContent = JSON.stringify({
          prerender: [{ where: { href_matches: '/products/*' }, eagerness: 'moderate' }],
          prefetch: [{ where: { href_matches: '/collections/*' }, eagerness: 'moderate' }]
        });
        document.head.appendChild(s);
        return;
      }
    } catch (e) { }
    /* Fallback (Safari/Firefox): prefetch del documento al primer toque/hover */
    var done = {};
    function pf(a) {
      if (!a || !a.href || done[a.href]) return;
      if (a.origin !== location.origin) return;
      if (!/\/(products|collections)\//.test(a.pathname)) return;
      if (Object.keys(done).length > 40) return;
      done[a.href] = 1;
      var l = document.createElement('link');
      l.rel = 'prefetch'; l.href = a.href; l.as = 'document';
      document.head.appendChild(l);
    }
    document.addEventListener('touchstart', function (e) { var a = e.target.closest && e.target.closest('a[href]'); if (a) pf(a); }, { passive: true, capture: true });
    document.addEventListener('mouseover', function (e) { var a = e.target.closest && e.target.closest('a[href]'); if (a) pf(a); }, true);
  }

  /* ── Arranque ── */
  function boot() {
    if (location.pathname.indexOf('/search') !== -1) onSearchPage();
    eagerFix();
    savingsBadges(document);
    mobileBar();
    window.addEventListener('resize', mobileBar);
    turbo();
    var grids = document.querySelectorAll('#ProductGridContainer, .product-grid');
    grids.forEach(function (g) {
      new MutationObserver(function () { savingsBadges(g); })
        .observe(g, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
